import { createContext, useState } from "react";
import { texts } from "../assets/data";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const toggleLanguage = (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    setLanguage((prevLang) => (prevLang === 'en' ? 'fr' : 'en'));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, texts}}>
      {/* TO DO - setLanguage redundant? */}
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;